export function formatUploadBytes(bytes) {
  const n = Math.max(0, Number(bytes) || 0);
  if (n < 1024) return `${Math.round(n)} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  if (n < 1024 * 1024 * 1024) {
    const mb = n / (1024 * 1024);
    return `${mb >= 100 ? mb.toFixed(0) : mb.toFixed(1)} MB`;
  }
  const gb = n / (1024 * 1024 * 1024);
  return `${gb >= 10 ? gb.toFixed(1) : gb.toFixed(2)} GB`;
}

export function formatUploadEta(seconds) {
  if (seconds == null || !Number.isFinite(seconds) || seconds < 0) return null;
  const s = Math.round(seconds);
  if (s < 15) return 'a few seconds left';
  if (s < 60) return `${s} sec left`;
  const m = Math.round(s / 60);
  if (m < 60) return `${m} min left`;
  const h = Math.floor(m / 60);
  const rem = m % 60;
  return rem ? `${h} hr ${rem} min left` : `${h} hr left`;
}

export function truncateFileName(name, max = 28) {
  const raw = String(name || 'Video');
  if (raw.length <= max) return raw;
  const dot = raw.lastIndexOf('.');
  const ext = dot > 0 ? raw.slice(dot) : '';
  const base = dot > 0 ? raw.slice(0, dot) : raw;
  const keep = Math.max(8, max - ext.length - 1);
  return `${base.slice(0, keep)}…${ext}`;
}

export function createVideoThumbnail(file) {
  return new Promise((resolve) => {
    if (!file || typeof document === 'undefined') {
      resolve(null);
      return;
    }
    const url = URL.createObjectURL(file);
    const video = document.createElement('video');
    video.preload = 'metadata';
    video.muted = true;
    video.playsInline = true;
    video.src = url;
    const cleanup = () => {
      try {
        URL.revokeObjectURL(url);
      } catch {
        /* ignore */
      }
    };
    const fail = () => {
      cleanup();
      resolve(null);
    };
    const timeoutId = window.setTimeout(fail, 4000);
    const finish = (value) => {
      window.clearTimeout(timeoutId);
      resolve(value);
    };
    video.onerror = () => {
      window.clearTimeout(timeoutId);
      fail();
    };
    video.onloadeddata = () => {
      try {
        const t = Number.isFinite(video.duration) ? Math.min(1.2, Math.max(0.1, video.duration * 0.04)) : 0.4;
        video.currentTime = t;
      } catch {
        window.clearTimeout(timeoutId);
        fail();
      }
    };
    video.onseeked = () => {
      try {
        const canvas = document.createElement('canvas');
        canvas.width = 160;
        canvas.height = 90;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(video, 0, 0, 160, 90);
        finish(canvas.toDataURL('image/jpeg', 0.72));
      } catch {
        finish(null);
      } finally {
        cleanup();
      }
    };
  });
}
